import { DateTime } from 'luxon';

export const ThityDaysFromNow = (date: Date) =>
  DateTime.fromJSDate(date).plus({ days: 30 }).toJSDate();
